/* Brands page — search filter + A-Z letter filter (transposes Brands.tsx behaviour) */
(function () {
  var root = document.querySelector('[data-brands-root]');
  if (!root) return;

  var search = root.querySelector('[data-brand-search]');
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-letter-group]'));
  var popular = root.querySelector('[data-popular]');
  var letterLinks = Array.prototype.slice.call(root.querySelectorAll('[data-letter-filter]'));
  var allLink = root.querySelector('[data-letter-all]');
  var activeLetter = '';

  var ACTIVE = ['bg-primary', 'text-primary-foreground'];
  var INACTIVE = ['bg-secondary', 'text-secondary-foreground', 'hover:bg-secondary/80'];

  function paint(el, on) {
    ACTIVE.forEach(function (c) { el.classList.toggle(c, on); });
    INACTIVE.forEach(function (c) { el.classList.toggle(c, !on); });
  }

  function apply() {
    var q = (search && search.value ? search.value : '').trim().toLowerCase();
    var searching = q.length > 0;
    if (popular) popular.hidden = searching || !!activeLetter;
    groups.forEach(function (group) {
      var letter = group.getAttribute('data-letter-group');
      var visible = 0;
      group.querySelectorAll('[data-brand-card]').forEach(function (card) {
        var show = (!activeLetter || letter === activeLetter) &&
          (!searching || card.getAttribute('data-brand-name').indexOf(q) !== -1);
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      group.style.display = visible ? '' : 'none';
    });
    letterLinks.forEach(function (link) {
      paint(link, link.getAttribute('data-letter-filter') === activeLetter);
    });
    if (allLink) paint(allLink, !activeLetter);
  }

  if (search) search.addEventListener('input', apply);

  letterLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      activeLetter = link.getAttribute('data-letter-filter');
      if (search) search.value = '';
      apply();
    });
  });

  if (allLink) allLink.addEventListener('click', function (e) {
    e.preventDefault();
    activeLetter = '';
    if (search) search.value = '';
    apply();
  });

  var fromUrl = new URLSearchParams(window.location.search).get('letter');
  if (fromUrl) {
    fromUrl = fromUrl.toUpperCase();
    var match = letterLinks.some(function (l) { return l.getAttribute('data-letter-filter') === fromUrl; });
    if (match) { activeLetter = fromUrl; apply(); }
  }
})();
